import { FamilyCard } from '@fs/zion-tree-person-info-cards'
import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField, Paragraph, Button } from '@fs/zion-ui'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { mapParentRelationshipToFamily } from '../../relationship/relationshipUtils'

export default function SwitchRelationshipParentsDialog({ relationship, onClose, onOk, ...overlay }) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')
  const families = {}
  const parentsList = []
  const family = mapParentRelationshipToFamily(relationship)
  const focusElementRef = useRef()

  if (family) {
    // switch parents
    const parent2 = family.parent2
    family.parent2 = family.parent1
    family.parent1 = parent2
  }
  parentsList.push(family)
  families.parents = parentsList
  families.spouses = []

  return (
    <DialogOverlay
      {...overlay}
      focusRef={focusElementRef}
      aria-labelledby="form-dialog-title"
      title={t('person.reference.confirmSwitchPersons', 'Confirm Switching Persons')}
    >
      <Paragraph size="sm">
        {t(
          'person.relationships.switchPersonsConfirmation',
          'Are you sure you want to switch persons in this relationship to following:'
        )}
      </Paragraph>
      {families && families.parents && (
        <FamilyCard
          focusFamily={families.parents[0]}
          families={families}
          type="parents"
          data-testid="switch-parents-family-card"
        />
      )}
      <TextField
        ref={focusElementRef}
        label={t('reason', 'Reason')}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmSwitchParentsInRelationshipBtn" onClick={() => onOk(reason)} type="submit" emphasis="high">
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="cancelSwitchParentsInRelationshipBtn" onClick={onClose}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
